import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5401be61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-container" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"cell-item\" data-v-5401be61><div class=\"label\" data-v-5401be61>支付方式</div><div class=\"value\" data-v-5401be61><img src=\"/images/wxpay.svg\" data-v-5401be61><span class=\"wx-pay-text\" data-v-5401be61>微信支付</span></div></div>", 1)
const _hoisted_4 = {
  key: 1,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_5 = { class: "form-content xag-flex-center" }
const _hoisted_6 = { class: "price-text xag-flex-col" }
const _hoisted_7 = { class: "xag-flex-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "合计金额：", -1))
const _hoisted_9 = { class: "xag-flex-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-unit" }, "￥", -1))
const _hoisted_11 = { class: "price-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price-text-tips" }, "如个人原因取消订单，定金不退回", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, reactive, Ref, ComputedRef, computed } from 'vue'
import appHost, { isApp } from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import { getApplyRecordDetail, checkPayOrderStatus } from '@/apis/device-replace-v3'
import {
  PayDetailItem,
  RecordDetailKeyDetail,
  RecordDetailReduceDetail,
} from '@/types/device-replace-v3'
import { Button, Dialog } from 'vant'
import { useRouter, Router } from 'vue-router'
import getRoute from '@/compositions/route'
import ProductWrapper from './components/pay-product-block.vue'
import { showToastLoading, clearToast, showToastSuccess } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-front-money',
  setup(__props) {

const $router: Router = useRouter()
const { query } = getRoute()
const guid = (query.value.guid as string) || ''
const currentSource = isApp ? 'app' : 'mini' // app/小程序
let onLeftClick = function () {
  clearInterval(timeId)
  $router.replace({
    name: 'device-replace-v3-record-detail',
    query: {
      guid,
    },
  })
}

const price: Ref<number> = ref(1000)
const detail = ref(null)
async function initPageData() {
  showToastLoading({
    message: '加载中...',
  })
  try {
    let data = await getApplyRecordDetail({ guid })
    let childProductMap = data.detail.reduce(
      (result: RecordDetailReduceDetail, item: RecordDetailKeyDetail) => {
        let current = result[item.exchange_product_code]
        if (current) {
          current.count++
        } else {
          result[item.exchange_product_code] = {
            child_product_guid: '',
            count: 1,
            guid: item.exchange_product_guid,
            images: item.images,
            is_main: 1,
            name: item.exchange_product_name,
            price: 0,
            product_guid: '',
            tax_rate: 0,
          }
        }
        return result
      },
      {}
    )
    detail.value = data
    detail.value.new_product_child = Object.keys(childProductMap).map((key) => childProductMap[key])
    // 当前申请单已失效
    if (data.status !== 11) {
      clearToast()
      return Dialog.confirm({
        message: '申请状态异常，无法支付定金。',
        confirmButtonText: '我知道了',
        className: 'repair-dialog',
        showCancelButton: false,
        width: 304,
      }).then(() => {
        $router.replace({
          name: 'device-replace-v3-record-detail',
          query: {
            guid,
          },
        })
      })
    }
  } catch (error) {}
  clearToast()
  Dialog.confirm({
    message: '支付定金后， 后续可支持更改套餐，请放心选购。',
    confirmButtonText: '我知道了',
    className: 'repair-dialog',
    showCancelButton: false,
    width: 304,
  })
}
// 轮询支付结果
let timeId: number
function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：<span style="color: #569AFF;"> 400-780-3131 </span>`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'device-replace-v3-dialog',
        allowHtml: true,
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkPayOrderStatus({ order_no: pay_order_no })
      .then((result) => {
        console.log('查询支付结果', result)
        if (result.status === 2) {
          // status:1-待付款 2-已付款 3-退回
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          setTimeout(() => {
            $router.replace({
              name: 'device-replace-v3-record-detail',
              query: {
                guid,
              },
            })
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
// 定金payInfo
const payFrontInfo = computed(() => {
  const payInfo: PayDetailItem | undefined =
    detail.value.pay_detail.find((info: PayDetailItem) => {
      return info.type === 1 // 筛选出定金的支付信息
    }) || undefined
  if (payInfo && payInfo.status === 1) {
    return payInfo
  }
  return null
})
async function sumbit() {
  let payOrderNo = payFrontInfo?.value?.pay_no || ''
  if (!payFrontInfo.value || !payOrderNo) {
    return Dialog.confirm({
      message: '无待支付定金',
      confirmButtonText: '我知道了',
      className: 'repair-dialog',
      width: 304,
    })
  }
  // 判断付款单创建时渠道与当前是否一致
  if (payFrontInfo.value.source && payFrontInfo.value.source !== currentSource) {
    return Dialog.confirm({
      message: `请到${
        payFrontInfo.value.source === 'app' ? '极飞农服APP端' : '极飞服务小程序'
      }完成支付`,
      confirmButtonText: '我知道了',
      className: 'repair-dialog',
      width: 304,
    })
  }
  try {
    appHost.onPay(payOrderNo) // 调用app支付
    handleSearchOrderPayStatus(payOrderNo)
  } catch (error) {
    console.log('订单申请失败-error', error)
    let message = error && error.message ? error.message : '申请失败'
    Dialog({
      message,
      confirmButtonText: '我知道了',
      className: 'repair-dialog',
      width: 304,
    })
  }
}
const popupsShow = ref(false)
function onUpdatePopupShow(show: boolean) {
  popupsShow.value = show
}

initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      title: "支付定金",
      isReturnLeftEvent: "",
      onLeftClick: _unref(onLeftClick)
    }, null, 8, ["onLeftClick"]),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ProductWrapper, {
            title: detail.value.client_name,
            productName: detail.value.new_product.name,
            productImages: detail.value.new_product.images,
            productChild: detail.value.new_product_child,
            price: price.value,
            onUpdatePopupShow: onUpdatePopupShow
          }, null, 8, ["title", "productName", "productImages", "productChild", "price"]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (detail.value && !popupsShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(price.value.toFixed(2)), 1)
                ])
              ]),
              _hoisted_12
            ]),
            _createVNode(_unref(Button), {
              type: "success",
              class: "xa-vant-button",
              style: {"width":"140px"},
              onClick: sumbit
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即支付 ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13
  ]))
}
}

})